import { css } from 'styled-components';
import { COLOURS } from './style';

const orangeButton = css`
  display: inline-block;
  box-sizing: border-box;
  height: auto;
  max-height: inherit;
  padding: 16px 24px;
  font-size: 16px;
  font-weight: 600;
  text-align: center;
  text-decoration: none;
  background-color: ${COLOURS.PRIMARY.ORANGE_LIGHT};
  color: ${COLOURS.TEXT.BODY};
  border-radius: 6px;
`;

const orangeButtonHover = css`
  background-color: #f49a00;
  color: ${COLOURS.TEXT.HEADING};
`;

export const Orange = {
  button: orangeButton,
  buttonHover: orangeButtonHover,
};
